// extracted by mini-css-extract-plugin
export default {"runId":"xJK14WBRPTUJ2aZ4bdpy"};